import { render, staticRenderFns } from "./oodrive-failure.vue?vue&type=template&id=6b39c742&"
import script from "./oodrive-failure.vue?vue&type=script&lang=js&"
export * from "./oodrive-failure.vue?vue&type=script&lang=js&"
import style0 from "./oodrive-failure.vue?vue&type=style&index=0&id=6b39c742&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports